// Empty stub — replaces heavy Node-only modules (re2js, semver, lru-cache)
// that are pulled in by unleash-client but unused in the browser.
export default {};
